// The body for the exercise library: the map lights the parts picked; an open exercise's small figure marks what it
// works. The drawing is in bodyShapes.js
import { ARM, BASE, MIRROR, SHAPES, drawnAs } from './bodyShapes';

/**
 * One figure, side 'front' or 'back'. Map: `selected` parts light up (and the `hovered` one); its paths carry
 * data-region for the page to listen on. An exercise's figure: `worked` = { main, others, all } marks the main muscle
 * strongest and the others lighter (all: full body, everything lighter)
 */
export const BodyFigure = ({ side, selected = [], hovered = '', worked = null, className = '' }) => {
  const main = worked && drawnAs(worked.main);
  const others = worked ? (worked.others || []).map(drawnAs) : [];
  const stateOf = ({ region, muscle }) => {
    if (worked) {
      if (worked.all) return ' is-also';
      if (muscle === main) return ' is-main';
      return others.includes(muscle) ? ' is-also' : '';
    }
    return `${selected.includes(region) ? ' is-on' : ''}${hovered === region ? ' is-hover' : ''}`;
  };

  return (
    <svg className={`mt-body ${className}`} viewBox="0 0 160 360" aria-hidden="true" focusable="false">
      <g className="mt-body__base">
        <ellipse {...BASE.head} />
        <path d={BASE.neck} />
        {BASE.half.map(([d, hangs], index) => [
          <path key={`${index}-l`} d={d} transform={hangs ? ARM : undefined} />,
          <path key={`${index}-r`} d={d} transform={hangs ? `${MIRROR} ${ARM}` : MIRROR} />,
        ])}
      </g>
      <g>
        {SHAPES[side].map((shape) => (
          <path
            key={shape.key}
            className={`mt-body__mu${stateOf(shape)}`}
            d={shape.d}
            transform={shape.transform}
            data-region={worked ? undefined : shape.region}
          />
        ))}
      </g>
    </svg>
  );
};
